import monitoringServiceBatchManualModal from './monitoring-service-batch-manual-modal.vue'
export default monitoringServiceBatchManualModal
